import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from "@material-ui/core";
import CustomSwitch from "../../../Common/CustomSwitch";

const useStyles = theme => ({
    content: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    description: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
    }
});

const SingleOption = props => {
    const { classes, title, checked, onChange, children } = props;

    return (
        <div className={classes.content}>
            <div className={classes.description}>
                <Typography variant="body1">
                    {title}
                </Typography>
                {children}
            </div>
            <CustomSwitch
                color="primary"
                checked={checked}
                onChange={(e) => onChange && onChange(e.target.checked)}
            />
        </div>
    );
};

SingleOption.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    children: PropTypes.node
};

export default withStyles(useStyles)(SingleOption);
